var _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLn7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 1,
    viewBox: "0 0 213 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 212.562,
    y2: 0.5,
    stroke: "url(#paint0_linear_921_2391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_921_2391",
    x1: 0,
    y1: 1,
    x2: 203.772,
    y2: 0.999562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn7);
export default __webpack_public_path__ + "static/media/Ln7.3f1c063e20fc4f7f46a92b46d1f39f7a.svg";
export { ForwardRef as ReactComponent };